import { CampaignStatus } from "../../../../types/enums/campaign-enums";
import { StoreActionType as Type } from "../../types";

type LiveCampaignFilterState = {
  data: number;
};

const initialState: LiveCampaignFilterState = {
  data: CampaignStatus.Active
};

export const matrixLiveCampaignFilterReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case Type.SET_CAMPAIGN_LIVE_CAMPAIGN_FILTER:
      return { ...state, data: action.payload } as LiveCampaignFilterState;
    default:
      return state;
  }
};
